import type { Topic } from "@/types/content";

export const topics: Topic[] = [
  {
    id: "city-observation",
    title: "城市观察计划",
    description: "用脚步和镜头，重新丈量我们每天经过却从未真正看见的街区。",
    cover:
      "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20dense%20city%20neighborhood%20at%20golden%20hour%2C%20warm%20terracotta%20rooftops%20and%20narrow%20streets%2C%20soft%20haze%2C%20editorial%20urban%20photography%2C%20cream%20and%20amber%20palette&width=900&height=700&seq=dy-topic-city&orientation=landscape",
    articleIds: ["bookstore-second-life", "night-running-map", "old-street-24h"],
  },
  {
    id: "craft-archive",
    title: "手艺人档案",
    description: "记录那些还在用双手工作的人，以及他们手上的时间。",
    cover:
      "https://readdy.ai/api/search-image?query=Artisan%20workshop%20detail%20with%20clay%20tools%20and%20unfinished%20ceramic%20vessels%20on%20a%20wooden%20table%2C%20warm%20natural%20light%2C%20earthy%20cream%20and%20rust%20palette%2C%20editorial%20craft%20photography&width=900&height=700&seq=dy-topic-craft&orientation=landscape",
    articleIds: ["jianzhan-tea-bowl", "clay-teapot-craft", "vinyl-comeback"],
  },
  {
    id: "screen-inside",
    title: "银幕内外",
    description: "不只聊作品，也聊作品背后那条高速运转的生产线。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinema%20projector%20room%20with%20warm%20light%20beam%20and%20film%20reels%2C%20dusty%20atmosphere%2C%20cinematic%20editorial%20photography%2C%20deep%20amber%20and%20cream%20tones&width=900&height=700&seq=dy-topic-screen&orientation=landscape",
    articleIds: ["short-drama-actors", "documentary-return", "music-festival-economy"],
  },
  {
    id: "slow-life-lab",
    title: "慢生活实验室",
    description: "每一次小规模的生活实验，都值得被完整记录一次。",
    cover:
      "https://readdy.ai/api/search-image?query=Calm%20morning%20kitchen%20scene%20with%20ceramic%20cups%2C%20fresh%20herbs%20and%20linen%20cloth%20on%20a%20wooden%20table%2C%20soft%20sunlight%2C%20muted%20cream%20and%20sage%20palette%2C%20editorial%20lifestyle%20photography&width=900&height=700&seq=dy-topic-slow&orientation=landscape",
    articleIds: ["slow-kitchen-weekend", "minimalism-after", "midnight-kitchen"],
  },
];